import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import axios from 'axios';
import MaterialTable from 'material-table';
import { Component } from 'react';
import { Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Redirect } from 'react-router-dom';
import { validateOtHours } from '../utils/validation';
import { customDownloadForOT } from "./../utils/customDownloadForOT";
import { hasPermission } from './../utils/usePermission';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from './Toaster/CommonToast';


export default class OTList extends Component {
  constructor(props) {
    super(props)
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    this.state = {
      financialInformations: [],
      selectedUser: null,
      editRedirect: false,
      deleteModal: false,
      year: currentYear,
      month: currentMonth,
      loading: true,
      showHoursModal: false,
      otHours: 0,
      selectedHoursData: null,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    }
  }

  csvDownload = () => {
    customDownloadForOT(this.state.financialInformations, `Ot_Info${this.state.year}/${this.state.month}`);
  }
  componentDidMount() {
    this.fetchData()
  }

  fetchData = () => {
    this.setState({ loading: true })
    const { year, month } = this.state;
    axios({
      method: "get",
      url: `overtime/list/${year}/${month}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        this.setState({ financialInformations: res.data });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };


  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      this.fetchData();
    });
  };

  onEditHours = (hoursData) => {
    console.log('hours Data ', hoursData);
    this.setState({
      showHoursModal: true,
      selectedHoursData: hoursData,
      otHours: '',
    });
  }

  handleSubmitOtHours = async () => {
    // debugger;
    const { selectedHoursData, otHours } = this.state;
    const token = localStorage.getItem("token");
    console.log("selectedHoursData", selectedHoursData)
    console.log("otHours", otHours)
    const errors = validateOtHours(
      otHours
    );

    const headers = { Authorization: `Bearer ${token}` };
    const otPayloadData = {
      hours: otHours
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      await axios.put(`overtime/update/${selectedHoursData?.id}`, otPayloadData, { headers });
      this.setState({
        toastMessage: "Overtime hours added successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false, showHoursModal: false, otHours: '' });
        this.fetchData()
      }, 900);

    } catch (error) {
      console.log("error", error);
      let errorMessage = "Failed to add overtime hours.";
      if (error.response) {
        if (error.response.status === 404) {
          errorMessage = error.response.data.err;
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: errorMessage,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false, showHoursModal: false });
      }, 900);
    }

  }

  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            {this.state.editRedirect ? (<Redirect to={{ pathname: '/salary-details', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            {this.state.viewRedirect ? (<Redirect to={{ pathname: '/salary-view', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>OT List of Employees </strong>
                  </div>
                </Card.Header>
                <Card.Body>

                  <Form className="mb-3 d-flex align-items-center">
                    <Form.Group className="mr-3">
                      <Form.Label>Year</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        name="year"
                        value={this.state.year}
                        onChange={this.handleFilterChange}
                      >
                        {[...Array(5)].map((_, index) => (
                          <option key={index} value={new Date().getFullYear() - index}>
                            {new Date().getFullYear() - index}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Month</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        name="month"
                        value={this.state.month}
                        onChange={this.handleFilterChange}
                      >
                        {Array.from({ length: 12 }, (_, i) => {
                          const monthNumber = ("0" + (i + 1)).slice(-2);
                          return (
                            <option key={monthNumber} value={monthNumber}>
                              {monthNumber}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                    {hasPermission('M10S3B2') && (
                      <Form.Group className="mr-5 display-btn">
                        <Button
                          className="button-filter info"
                          variant="outline "
                          onClick={this.csvDownload}
                        // disabled={!this.state.project || (!this.state.startDate && !this.state.endDate && this.state.project !== "all")}
                        >
                          <i className="fas fa-file-csv"></i>
                        </Button>
                      </Form.Group>
                    )}
                  </Form>

                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      columns={[
                        { title: 'EMP ID', field: 'empid' },
                        { title: 'Full Name', field: 'employee.fullName' },
                        { title: 'Hours', field: 'hours' },
                        { title: 'Hour Rate', field: 'hour_rate' },
                        { title: 'Total Amount', field: 'total_amount' },
                        //{ title: 'Emp Type', field: 'employmentType' },
                        // {
                        //   title: 'Payment Date', field: 'dateOfPayment',
                        //   render: rowData =>
                        //     rowData.dateOfPayment ? DateTimeFormat(rowData.dateOfPayment) : 'N/A'
                        // },
                        {
                          title: 'Action',
                          render: rowData => (
                            <div style={{ display: 'flex' }}>
                              {hasPermission('M10S3B1') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Salary Details</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2" onClick={() => this.onEditHours(rowData)}><i className="far fa-edit"></i></Button>
                                </OverlayTrigger>
                              )}
                            </div>
                          )
                        },
                      ]}
                      data={this.state.financialInformations.map(({ tableData, ...rest }) => rest)}
                      options={{
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100]
                      }}
                      title="OT List"
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
              <Modal show={this.state.showHoursModal} onHide={() => this.setState({ showHoursModal: false })}>
                <Modal.Header closeButton>
                  <Modal.Title>Over Time (Hours)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group>
                    <Form.Label className='required'>Hours</Form.Label>
                    <Form.Control
                      name='otHours'
                      placeholder="Enter overtime hours"
                      value={this.state.otHours}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d{0,3}$/.test(input)) {
                          const errors = validateOtHours(input);
                          this.setState({
                            otHours: input,
                            errors: {
                              ...this.state.errors,
                              otHours: errors.otHours,
                            },
                          });
                        }
                      }}
                    // onChange={(e) => this.setState({ otHours: e.target.value })}
                    />
                  </Form.Group>
                  <span className="login-error">
                    {this.state.errors.otHours && <small className="text-danger">{this.state.errors.otHours}</small>}
                  </span>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="outline-danger" onClick={() => this.setState({ showHoursModal: false })}>
                    Cancel
                  </Button>
                  <Button variant="outline-primary" onClick={this.handleSubmitOtHours}>
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>

            </div>
          </div>
        </CommonLoader>
      </>
    )
  }
}
